import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DatiBilancioWarningsService } from './warnings/dati-bilancio.warnings';
import { DatiBilancioFieldValidators } from './validators/dati-bilancio.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [DatiBilancioWarningsService, DatiBilancioFieldValidators],
})
export class DatiBilancioFormModule {}
